import { useState, useEffect } from "react";
import axios from "axios";
import "../src/assets/components/myinfo.css";
import { useParams, useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";
import Swal from "sweetalert2";

function Readrequest() {
  const [reqInfo, setReqInfo] = useState({});
  const { brgyId } = useParams();
  const navigate = useNavigate();
  const [isPhotoVisible, setIsPhotoVisible] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Make an API call to fetch user information based on brgyId
        const response = await axios.get(
          `https://brgytracerappserver.onrender.com/readrequest/${brgyId}`
        );
        const userData = response.data; // Adjust this based on your API response structure
        setReqInfo({ ...userData, brgyId });
      } catch (error) {
        console.error("Error fetching user information:", error);
      }
    };

    fetchData(); // Call the fetchData function when the component mounts
  }, [brgyId]); // Re-run the effect when brgyId changes

  const handleBack = () => {
    navigate("/viewrequest");
  };

  const hidePhoto = () => {
    setIsPhotoVisible(true);
  };

  const showPhoto = () => {
    setIsPhotoVisible(!isPhotoVisible);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "User Request!",
      text: "Do you want to continue!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Continue!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Format the birthdate to yyyy-mm-dd
        const formattedBirthdate = new Date(reqInfo.birthdate)
          .toISOString()
          .split("T")[0];

        // Prepare the updated user data
        const updatedUserData = {
          firstname: reqInfo.firstname,
          middlename: reqInfo.middlename,
          lastname: reqInfo.lastname,
          age: reqInfo.age,
          birthdate: formattedBirthdate,
          gender: reqInfo.gender,
          cellnumber: reqInfo.cellnumber,
          civilstatus: reqInfo.civilstatus,
          religion: reqInfo.religion,
          nationality: reqInfo.nationality,
          occupation: reqInfo.occupation,
          recentaddress: reqInfo.recentaddress,
          presentaddress: reqInfo.presentaddress,
          username: reqInfo.username,
          email: reqInfo.email,
          password: reqInfo.password,
          role: reqInfo.role,
          photo: reqInfo.photo,
        };

        axios
          .put(
            `https://brgytracerappserver.onrender.com/readrequest/${reqInfo.brgyId}`,
            updatedUserData
          )
          .then((res) => {
            if (res.data.status === "success") {
              Swal.fire({
                title: "User Information Updated!",
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Okay",
              }).then(() => {
                navigate("/viewrequest");
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Something went wrong!",
                text: "Update failed!",
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Something went wrong!",
              text: error.response?.data?.message || "System error!!",
            });
          });
      }
    });
  };

  return (
    <div className="Myinfo-parent">
      <AutoLogout />
      <div className="Myinfo-holder showimage">
        <div className="account-bar">
          <h3>Account Information</h3>
          <div className="account-content">
            <div>
              <label>Username:</label>
              <p>{reqInfo.username}</p>
            </div>
            <div>
              <label>Email:</label>
              <p>{reqInfo.email}</p>
            </div>
            <div>
              <label>Role:</label>
              <p>{reqInfo.role}</p>
            </div>
            <div className="isShowphoto">
              <p onClick={showPhoto}>View photo</p>
            </div>
          </div>
        </div>
        <div className="info-bar">
          <h3>Personal Information</h3>
          <div className="info-content">
            <div>
              <p>
                BrgyId:<label>{brgyId}</label>
              </p>
            </div>
            <div>
              <label>First Name:</label>
              <p>{reqInfo.firstname}</p>
            </div>
            <div>
              <label>Middle Name:</label>
              <p>{reqInfo.middlename}</p>
            </div>
            <div>
              <label>Family Name:</label>
              <p>{reqInfo.lastname}</p>
            </div>
            <div>
              <label>Age:</label>
              <p>{reqInfo.age}</p>
            </div>
            <div>
              <label>Birth Date:</label>
              <p>{reqInfo.birthdate}</p>
            </div>
            <div>
              <label>Gender:</label>
              <p>{reqInfo.gender}</p>
            </div>
            <div>
              <label>Civil Status:</label>
              <p>{reqInfo.civilstatus}</p>
            </div>
            <div>
              <label>Religion:</label>
              <p>{reqInfo.religion}</p>
            </div>
            <div>
              <label>Nationality:</label>
              <p>{reqInfo.nationality}</p>
            </div>
            <div>
              <label>Occupation:</label>
              <p>{reqInfo.occupation}</p>
            </div>
            <div>
              <label>Phone Number:</label>
              <p>{reqInfo.cellnumber}</p>
            </div>
            <div>
              <label>Recent Address:</label>
              <p>{reqInfo.recentaddress}</p>
            </div>
            <div>
              <label>Present Address:</label>
              <p>{reqInfo.presentaddress}</p>
            </div>
          </div>
        </div>
        <div className="button-container">
          <button className="backbutton" type="button" onClick={handleUpdate}>
            Update
          </button>
          <button className="backbutton" type="button" onClick={handleBack}>
            Back
          </button>
        </div>
        <div className={`ishidden ${isPhotoVisible ? "hide-it" : ""}`}>
          <div className="photo-container">
            <img src={reqInfo.photo} alt="photos" />
            <button onClick={hidePhoto}>X</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Readrequest;
